// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pzTZ","title":"styles_title__2BfGi"};